import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { deviceTokenAtom } from '@/features/DeviceCreate/DeviceCreate.store';
import type { DeviceTokenModel } from '@/features/DeviceCreate/DeviceCreate.types';

// Get Activation Token
const useDeviceToken = (deviceUid: string) => {
  const [, setTokens] = useAtom(deviceTokenAtom);
  const deviceTokenQuery = useQuery({
    queryKey: [`devices/generate_token/${deviceUid}`],
    enabled: false
  });

  useEffect(() => {
    if (deviceTokenQuery.isSuccess) {
      setTokens((prevTokens) => ({
        ...prevTokens,
        [deviceUid]:
          (deviceTokenQuery.data as DeviceTokenModel | undefined)?.token || ''
      }));
    }
  }, [deviceTokenQuery.data, deviceTokenQuery.isError]);

  return deviceTokenQuery;
};
export default useDeviceToken;
